import { Card, CardActions, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { TwoFactorSettingsSectionPlaceholder } from "./twoFactorSettingsSectionPlaceholder";

interface TwoFactorSettingsSectionProps {
    isFetching: boolean;
    is2FaEnabled: boolean;
}

export function TwoFactorSettingsSection({ isFetching, is2FaEnabled }: TwoFactorSettingsSectionProps) {
    return (
        <Grid container spacing={4} className="two-factor-settings-section">
            <Grid item xs={12}>
                <div className="two-factor-settings-category">Manage Two-Factor Authentication</div>
            </Grid>
            <Grid item xs={12} className="two-factor-settings-section-header">
                <div className="title">Use Two-Factor Authentication</div>
                <div className="sub-title">To secure your profile, turn on two-factor authentication.</div>
            </Grid>
            <Grid item xs={12}>
                {isFetching ? (
                    <TwoFactorSettingsSectionPlaceholder />
                ) : (
                    <div className="two-factor-settings-card-container">
                        <Card className={"two-factor-settings-card " + (is2FaEnabled ? " selected" : "")}>
                            <CardActions>
                                <div className="two-factor-settings-card-actions">
                                    <FormControlLabel
                                        label="I would like to use two-factor authentication."
                                        control={
                                            <Checkbox
                                                checked={is2FaEnabled}
                                                onChange={() => {
                                                    // TODO open password validation dialog - https://dev.azure.com/asebp-apps/products/_workitems/edit/32076
                                                }}
                                            />
                                        }
                                    />
                                </div>
                            </CardActions>
                        </Card>
                    </div>
                )}
            </Grid>
        </Grid>
    );
}
